const IPIFY_URL = "https://api.ipify.org?format=json";

let cachedIp: string | null = null;
let fetchPromise: Promise<string | null> | null = null;

/**
 * Fetches the client's public IP once and caches it. Safe to call from
 * prepareHeaders; subsequent calls return the cached value.
 */
export async function getClientIp(): Promise<string | null> {
  if (cachedIp) return cachedIp;
  if (fetchPromise) return fetchPromise;
  fetchPromise = (async () => {
    try {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 5000);
      const res = await fetch(IPIFY_URL, { signal: controller.signal });
      clearTimeout(timeout);
      if (!res.ok) return null;
      const data = (await res.json()) as { ip?: string };
      const ip = data?.ip?.trim() ?? null;
      if (ip) cachedIp = ip;
      return ip;
    } catch {
      return null;
    }
  })();
  return fetchPromise;
}
